import React, { useEffect, useState } from "react";
import { Box, Toolbar, Typography } from "@mui/material";
import TableRowsLoader from "../../../components/common/Loader/tableLoader";
import AccountsTable from "../../../components/accountsTable/AccountsTable";
import NewAccountDrawer from "../../../components/newAccountDrawer/NewAccountDrawer";
import "./styles.scss";
import { getAccounts } from "../../../services/accountService";
import { AccountType } from "../../../types/genericType";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedAccount } from "../../../redux/features/accountSlice";
import { DropdownOptions } from "../../../components/common/Dropdown/Dropdown";
import { getClients } from "../../../services/transactionService";
import { generateClientName } from "../../../utils/utils";
import { RootState } from "../../../redux/store";

const Accounts = () => {
  const { role } = useSelector((state: RootState) => state.userDetails);
  const clientView = role === "Client";
  const [accountsData, setAccountsData] = useState<AccountType[]>([]);
  const [openEditDrawer, setOpenEditDrawer] = useState(false);
  const { selectedAccount } = useSelector((state: any) => state.accountsState);
  const [clientOptions, setClientOptions] = useState<DropdownOptions[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  

  const dispatch = useDispatch();

  const updateSelectedAccount = (account: AccountType) => {
    dispatch(setSelectedAccount(account));
  };

  const getClientsData = () => {
    getClients()
      ?.then((res) => {
        const clients: DropdownOptions[] = [];
        res.forEach((client: any) => {
          clients.push({
            value: client.id,
            label: generateClientName(client),
          });
        });
        setClientOptions(clients);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAccountsData = () => {
    getAccounts()
      .then((res) => {
        setIsLoading(false);
        setAccountsData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    getAccountsData();
    getClientsData();
  }, []);

  return (
    <>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          margin: "0px 15px",
        }}
      >
        <Typography className="accounts-title">Accounts</Typography>
        <NewAccountDrawer
          getAccountsData={getAccountsData}
          selectedAccount={selectedAccount}
          updateSelectedAccount={updateSelectedAccount}
          openEditDrawer={openEditDrawer}
          setOpenEditDrawer={setOpenEditDrawer}
          clientOptions={clientOptions}
          clientView={clientView}
        />
      </Toolbar>
      <Box sx={{ margin: "20px 40px" }}>
        {!isLoading ? (
          <AccountsTable
            accountsData={accountsData}
            selectedAccount={selectedAccount}
            updateSelectedAccount={updateSelectedAccount}
            setOpenEditDrawer={setOpenEditDrawer}
            clientView={clientView}
          />
        ) : (
          <TableRowsLoader rowsNum={10} />
        )}
      </Box>
    </>
  );
};

export default Accounts;
